export const COLORS = {
    'yellow-300': '#fff0d7',
    'neutral-200': 'var(--color-neutral-200, #efedf2)',
    'neutral-500': 'var(--border-border-secondary, #dddae3)',
    'neutral-700': '#ECEAE3',
    'pink-300': '#feedea',
    'pink-500': '#FFC2EC',
    'base-color': '#FFF',
    'orange-500': '#F05537',
    'blue-300': '#324EFC',
    'loading-bg':
        'linear-gradient(90deg, rgba(255, 255, 255, 0.18) 31.05%, rgba(0, 0, 0, 0.00) 65.45%, rgba(255, 255, 255, 0.11) 65.45%), #EEEDF2',
};
